import script from "./pkg.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./pkg.vue?vue&type=script&setup=true&lang=js"
export * from "./pkg.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./pkg.vue?vue&type=script&setup=true&lang=js"

import "./style.scss.scss?vue&type=style&index=0&lang=scss&external!=!./style.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__